import { Component } from '@angular/core';
import { DefaultLayoutComponent } from '../../layout/default-layout/default-layout.component';

@Component({
    selector: 'app-not-found',
    imports: [DefaultLayoutComponent],
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.css'
})
export class NotFoundComponent {}
